import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import EyeIcon from 'mdi-react/EyeIcon';
import EmailIcon from 'mdi-react/EmailIcon';
import AccountSearchIcon from 'mdi-react/AccountSearchIcon';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import renderFileInputField from '../../../../shared/components/form/FileInput';
import renderSelectField from '../../../../shared/components/form/Select';
import renderMultiSelectField from '../../../../shared/components/form/MultiSelect';
import $ from 'jquery';
import readXlsxFile from 'read-excel-file';
import XLSX from 'xlsx';
import { make_cols } from './MakeColumns';
import { SheetJSFT } from './types';
import Sheet from '../../../../images/BIN_MASTER_v1.xlsx';
import Select from 'react-select';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';
import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import {addAnalytics, paginationAnalytics} from '../../../Common/analytics';
import DarkBackground from '../../../Common/backgroundLoader';


var url = window.location.hostname;
var port = window.location.port;




const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xlsx';


const exportToCSV = (csvData, fileName) => {
  const ws = XLSX.utils.json_to_sheet(csvData);
  const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  const data = new Blob([excelBuffer], { type: fileType });
  FileSaver.saveAs(data, fileName + fileExtension);
}



class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };




  constructor() {
    super();
    this.fetchBinData = this.fetchBinData.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleFailed = this.toggleFailed.bind(this);
    this.Successtoggle = this.Successtoggle.bind(this);
    this.ConfirmToggle = this.ConfirmToggle.bind(this);
    this.openConfirm = this.openConfirm.bind(this);

    /*this.onMasterChange = this.onMasterChange.bind(this);*/

    this.state = {
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      loadingGRNData: false,
      showInvalidBaseItem: false,
      showInvalidProductItem: false,
      fileNameVal: 'masterFile',
      showResponseData: false,
      showBaseResponseData: false,
      showProductResponseData: false,
      responseUpdatedBaseData: false,
      responseUpdatedProductData: false,
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      postsBase: [],
      postsProduct: [],
      postsTester: [],
      tableRowsBase: [],
      tableRowsProduct: [],
      tableRowsTester: [],
      ErrorRowData: [],
      modal: false,
      modalFailed: false,
      ConfirmModal: false,
      Successmodal: false,
      loading: false,

      isLoading: true,
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      show_process_data: true,

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      BinMasters: ["Aisle", "Bin", "Bin Address", "Level", "Rack", "Rack Type", "Storage Type", "Zone Name", "Zone No."],
      /*BasePackCodes:["Base Pack Code" , "Zone Name" , "Zone No"],*/

      BasePackCodes: [{ "Base Pack Code": "fghj", "Zone Name": "fghj", "Zone No": "fghj" }],

      validation: {
        "Bin Master": {
          "Aisle": "string",
          "Bin": "number",
          "Bin Address": "string",
          "Level": "number",
          "Rack": "number",
          "Rack type": "string",
          "Storage type": "string",
          "Zone Name": "string",
          "Zone No.": "number",
        },

        "Basepack Zone": {
          "Base Pack Code": "string",
          "Zone Name": "string",
          "Zone No.": "number",
        },

        "Product Master": {
          "Company": "string",
          "Brand": "number",
          "Sub Brand": "string",
          "LB SKU ID": "number",
          "LB SKU Product Name": "number",
          "Basepack Code": "string",
          "CBU Code": "string",
          "Shade Code": "string",
          "Shade Name": "number",
          "Category": "string",
          "Sub-Category": "string",
          "Price Lot": "string",
          "MRP": "string",
          "UOM": "string",
          "UPC": "string",
          "Pack Size": "string",
          "Pack Size UOM": "string",
          "EAN": "string",
          "ICLD EAN": "string",
          "Weight": "string",
          "Volume": "string",
          "ICLD Volume": "string",
          "SKU7 Code": "string",
          "SKU5 Code": "string",
          "Offer": "string",
          "Tester": "string",
          "Storage Type": "string",
          "Status": "string",
          "Created Date Time": "string",
          "Updated Date Time": "string",
        },

        "Tester Basepack Master": {
          "S. No.": "number",
          "BasePack Code": "string",
          "Basepack Description": "string",
          "Bin": "string",


        },


      }
    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };



  /*onMasterChange(event){
    this.setState({
      value: event.target.value
    })
    console.log(this.state.value);

  }*/

  componentDidMount() {
    this.fetchBinData();
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = Util.getCookie('token');
    var location = Util.getCookie('selectedLocation');
    var username = Util.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

    localStorage.setItem('userName', username);
  }



  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  Successtoggle() {
    this.setState(prevState => ({ Successmodal: !prevState.Successmodal }));
  }

  toggleFailed() {
    this.setState(prevState => ({ modalFailed: !prevState.modalFailed }));
  }

  ConfirmToggle() {
    this.setState(prevState => ({ ConfirmModal: !prevState.ConfirmModal }));
  }

  openConfirm() {
    this.setState({
      ConfirmModal: true
    })

  }



 

  fetchBinData() {


    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true
    })


    const payload={ master_type: "retailer_area_master",
    location: this.state.selectedLocation,}
API.post("/customer/view/v1/", { param: payload })

      .then(response => response.data)

      .then(data => {

        console.log("Area Data", data);

        // if (err) throw err;

        this.setState({ posts: data.data })

      })

      .then(async () => {

        this.setState({ tableRows: this.assemblePosts(), isLoading: false })

        console.log(this.state.tableRows);

      });
  }


 



  assemblePosts = () => {

    let posts = this.state.posts.map((post) => {

      return (

        {

          area_code: post.area_code,

          retailer_code: post.retailer_code



        }

      )

    });

    this.setState({
      loading_overlay: false
    })

    return posts;

  }


 




  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    console.log(this.state.showInvalidItem)
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;
    const { ConfirmModal } = this.state;


    const data = {

      columns: [

        {

          label: 'Retailer Code',

          field: 'retailer_code',
          sort: 'asc',

        },

        {

          label: 'Area code',

          field: 'area_code',
          sort: 'asc',

        },



      ],

      rows: this.state.tableRows,

    }


   


    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>


         



          {
            this.state.showFetchBinData && (

              <CardBody style={{ marginTop: 20 }}>
                <div className="table_header" style={{ borderBottomWidth: '0px' }}>

                  <h4 style={{ fontWeight: 'bold', width: '80%', paddingTop: 10, float: 'left' }} className="subhead red-text">HUL Master</h4>

                  <span
                    className="pull-right"
                    onClick={() => exportToCSV(this.state.posts, "AreaMaster")}
                    style={{
                      fontSize: "17px",
                      paddingRight: "0px",
                      cursor: "pointer",
                      color: "#919193",
                      paddingTop: "9px",
                    }}
                  >
                    <FontAwesomeIcon icon={faDownload}></FontAwesomeIcon>
                  </span>

                </div>
                <hr style={{ marginTop: '30px', marginBottom: '0px' }} />
                <MDBDataTable
                  striped
                  bordered
                  sortable={false}
                  hover
                  onPageChange = {(pageNumber) => paginationAnalytics(pageNumber.activePage,pageNumber.pagesAmount, 'retailer_area_master_view', 'datatable_pagination_change' )}
                  data={data}
                />
              </CardBody>

            )}



        </Card>
        <Modal
          isOpen={modal}
          toggle={this.toggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{ right: 15 }} onClick={this.toggle} />


          </div>
          <div className="modal__body" style={{ paddingTop: 55, paddingBottom: 20 }}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{ color: '#4ce1b6' }} />
            <h4>Successfully Validated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{ backgroundColor: '#24d6a3', color: '#fff' }} className="modal_ok" onClick={this.togglePressCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}

          style={{ maxWidth: 578 }}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{ right: 15 }} onClick={this.toggleFailed} />


          </div>
          <div className="modal__body" style={{ paddingTop: 55, paddingBottom: 20 }}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{ color: 'red' }} />
            <h4>This file contains some errors. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{ backgroundColor: '#ddd', color: '#fff' }} className="modal_ok" onClick={this.togglePressCancel}>Cancel</Button>

          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={Successmodal}
          toggle={this.Successtoggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{ right: 15 }} onClick={this.Successtoggle} />


          </div>
          <div className="modal__body" style={{ paddingTop: 55, paddingBottom: 20 }}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{ color: '#4ce1b6' }} />
            <h4>{this.state.successCreatedMessage}</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{ backgroundColor: '#24d6a3', color: '#fff' }} className="modal_ok" onClick={this.SuccesstoggleCancel}>Ok</Button>
          </ButtonToolbar>
        </Modal>


        <Modal
          isOpen={ConfirmModal}
          toggle={this.ConfirmToggle}
          style={{ maxWidth: 456 }}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{ right: 15 }} onClick={this.ConfirmToggle} />


          </div>
          <div className="modal__body" style={{ paddingTop: 55, paddingBottom: 20 }}>
            <span className="lnr lnr-thumbs-up modal__title-icon" style={{ color: '#4ce1b6' }} />
            <h4 style={{ fontSize: 18 }}> Are you sure you want to proceed?</h4>
            <br />
            <h3 style={{ fontSize: 17 }}><strong> NOTE: </strong> Duplicate entries will be updated if you proceed. </h3>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{ backgroundColor: '#24d6a3', color: '#fff', marginRight: 8 }} className="modal_ok" onClick={this.processData}>Ok</Button>
            <Button style={{ backgroundColor: '#24d6a3', color: '#fff' }} className="modal_ok" onClick={this.ConfirmToggle}>Cancel</Button>
          </ButtonToolbar>
        </Modal>





      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));